<div class="container">
    <mat-card class="example-card">
      <mat-card-header>
        <!-- <div mat-card-avatar class="example-header-image"></div> -->
        <mat-card-title>Ekasi App</mat-card-title>
        <mat-card-subtitle>Account Payment</mat-card-subtitle>
      </mat-card-header>
      <img mat-card-image src="assets/payment-background.jpg" alt="Payment background image">
      <mat-card-content>
        <form action="https://www.payfast.co.za/eng/process" method="post">
          <input type="hidden" name="merchant_id" value="16695856">
          <input type="hidden" name="merchant_key" value="7hh3kzym1j3ph">
          <mat-form-field class="full-width">
            <mat-label>Amount</mat-label>
            <input matInput type="text" name="amount" [value]="clientModel.amount">
          </mat-form-field>
          <input type="hidden" name="m_payment_id" [value]="transactionId">
          <input type="hidden" name="item_name" value="Ekasi account">
          <input type="hidden" name="name_first" [value]="clientModel.clientName">
          <input type="hidden" name="name_last" [value]="clientModel.clientLastName">
          <input type="hidden" name="email_address" [value]="clientModel.clientEmail">
          <input type="hidden" name="cancel_url" value="https://ekasi-app.web.app/failed">
          <input type="hidden" name="notify_url" value="https://us-central1-ekasi-app.cloudfunctions.net/paymentNotification">
          <input type="hidden" name="return_url" value="https://ekasi-app.web.app/success">
          <button type="submit" mat-stroked-button color="primary" class="full-width">Pay Now</button>
        </form>
      </mat-card-content>
      <mat-card-actions>
        <button mat-stroked-button color="primary" class="full-width">Open Ekasi App</button>
        <!-- <button mat-button>SHARE</button> -->
      </mat-card-actions>
    </mat-card>
  </div>
